export default "__VITE_ASSET__DQ2D4EPp__"